export default "__VITE_ASSET__634fadb2__"